import { ValidationRule } from './types';

const rules: ValidationRule[] = [];

/**
 * Registers a validation rule. Called at module load time by every rule file.
 *
 * Throws on id collision rather than silently replacing — duplicate ids were
 * almost always a copy/paste bug (two rules with the same id but different
 * logic), and the old overwrite behavior made them invisible. If replacement
 * is legitimately required, clear the registry first.
 */
export const registerRule = (rule: ValidationRule): void => {
  if (rules.some(r => r.id === rule.id)) {
    throw new Error(
      `[validation] Rule id collision: "${rule.id}" is already registered. ` +
      `Rule ids must be unique across all rule modules.`
    );
  }
  rules.push(rule);
};

export const getRules = (): ReadonlyArray<ValidationRule> => rules;

export const getRule = (id: string): ValidationRule | undefined =>
  rules.find(r => r.id === id);
